import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import type SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Accordion, Stack, Text, Title } from "@mantine/core";
import type ValorantGradientText from "@modules/valorant/components/ValorantGradientText";
import { IconChevronDown, IconHelpCircleFilled } from "@tabler/icons-react";
import type React from "react";
import classes from "./faq.module.css";

export interface IQuestion {
  question: string;
  answer: string;
  className?: string;
}

type AllowedComponents = typeof ValorantGradientText | typeof SSLoLGradientText;

interface IFAQProps {
  questions: IQuestion[];
  TextGradient: AllowedComponents;
}

const FAQ: React.FC<IFAQProps> = ({ questions = [], TextGradient }) => {
  const { t } = useAppTranslation("components.faq");
  const questionsAnswer = questions?.map((item, index) => (
    <Accordion.Item
      key={item.question}
      className="w-full border-primary-dark-text bg-primary-background"
      value={String(index)}
    >
      <Accordion.Control
        className="border-primary-dark-text bg-primary-background"
        icon={<IconHelpCircleFilled className="text-primary-white" size={22} />}
      >
        <Title
          className="p-2 font-bold font-secret-narrow text-primary-white"
          order={3}
          size="md"
        >
          {item.question}
        </Title>
      </Accordion.Control>
      <Accordion.Panel className="border-primary-dark-text bg-primary-darker">
        <Text
          className={`px-4 py-5 font-inter font-normal text-primary-dark-text ${item.className}`}
          dangerouslySetInnerHTML={{ __html: item.answer }}
          size="sm"
        />
      </Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <Stack
      align="center"
      className="xs:w-9/12 p-4 sm:w-10/12 sm:p-6 md:w-2/3 lg:w-4/3 lg:p-10"
      gap={35}
    >
      <SSHeadline
        props={{
          title: {
            fz: 30,
          },
        }}
      >
        <Emoji.Thinking />
        <TextGradient> {t("questions")} </TextGradient>
        <SSWhiteText>{t("frequentlyAsked")}</SSWhiteText>
      </SSHeadline>
      <Accordion
        chevron={<IconChevronDown size={20} stroke={3} />}
        chevronSize={20}
        className="flex w-full flex-col items-center"
        classNames={classes}
        radius="md"
        variant="separated"
      >
        {questionsAnswer}
      </Accordion>
    </Stack>
  );
};

export default FAQ;
